import React , { useState }from 'react';
import { Search } from "lucide-react";
import { Code } from "lucide-react";
import toggle from "../../assests/toggle.png";
export const TabNavigation = ({
  tabs,
  activeTab,
  onTabChange,
     

}) => {
  const [isToggled, setIsToggled] = useState(false);
  return (
<div className="border-b border-gray-200 mb-4">
    
      <div className="flex justify-between items-center px-5 py-4">
        <div className='grid'>
  <div className="text-[#424242] pt-2" style={{fontSize:'24px', fontWeight:'700'}}>
Domain Management  </div>
<p className=''>Detailed overview of the selected asset under the chosen product and domain hierarchy.</p>
</div>

  <label className="flex items-center cursor-pointer select-none">
    <input
      type="checkbox"
      className="sr-only"
      checked={isToggled}
      onChange={() => setIsToggled(!isToggled)}
    />

<div className="flex items-center gap-[1px] border border-gray-300 rounded-full  transition-all duration-300 bg-white">
      <div
        className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 ${
          isToggled ? "bg-gray-400" : "bg-[#80C6AD]"
        }`}
      >
        <img
          src={toggle}
          alt="toggle"
          className="w-6 h-6 object-contain"
        />
      </div>
      <span
        className={`text-sm font-medium px-2 py-0.5 rounded-full transition-all duration-300 ${
          isToggled
            ? "bg-[#80C6AD] text-white"
            : "text-gray-700"
        }`}
      >
        Dev
      </span>
    </div>
  </label>
</div>


  
<nav className="-mb-px flex gap-[10px] mb-[10px] p-[20px]">
  {tabs.map((tab) => (
<button
      key={tab.id}
      onClick={() => onTabChange(tab.id)}
      className={`
        relative flex items-center gap-2 h-[40px]
        px-3 py-2 font-medium text-sm transition-colors duration-200
        ${activeTab === tab.id
          ? "bg-[#bb1ccc] text-[#fff] border border-[#bb1ccc] rounded-[9px] font-normal"
          : "bg-white text-[#404040] border border-[#818181] hover:text-gray-800 rounded-md"
        }
      `}
>
      {tab.label}
      {tab.count && (
<span
          className={`
            ml-2 px-2 py-0.5 text-xs font-medium
            ${activeTab === tab.id
              ? "bg-[#fff] text-[#bb1ccc] rounded-[4px]"
              : "bg-[#bb1ccc] text-[#fff] rounded-[4px]"
            }
          `}
>
          {tab.count}
</span>
      )}
 
      {activeTab === tab.id && (
<span className="absolute bottom-0 left-0 top-[68px] w-full h-[2px] bg-[#bb1ccc] rounded-b-md" />
      )}
</button>
  ))}
</nav>

 
 
    </div>
  );
};